<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <p align="center">
      <color-picker v-model="color" @color-change="onColorChange()"></color-picker>
    </p>
    <h1 v-html="color"></h1>
  </div>
</template>

<script>
import ColorPicker from 'vue-color-picker-wheel'
const axios = require('axios')

export default {
  name: 'LightPicker',
  components: { ColorPicker },
  props: {
    msg: String
  },
  data() {
    return {
      color: '#aaaaaa'
    }
  },
  methods: {
    async onColorChange() {
      console.log('Color changed to ' + this.color)
      await axios.post('https://curtisporter.com/colorwall/setColor', { 'color': this.color })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
